(() => {
  const QUESTIONS = [
    {
      question: 'Which quality do you value most in yourself?',
      answers: [
        { text: 'Courage under pressure', points: { gryffindor: 3, slytherin: 1 } },
        { text: 'Curiosity and intelligence', points: { ravenclaw: 3 } },
        { text: 'Loyalty and kindness', points: { hufflepuff: 3 } },
        { text: 'Ambition and determination', points: { slytherin: 3, gryffindor: 1 } }
      ]
    },
    {
      question: 'In a difficult situation, what is your first instinct?',
      answers: [
        { text: 'Take action immediately', points: { gryffindor: 3 } },
        { text: 'Think through every angle', points: { ravenclaw: 3 } },
        { text: 'Protect the people around me', points: { hufflepuff: 3, gryffindor: 1 } },
        { text: 'Figure out the smartest way to win', points: { slytherin: 3, ravenclaw: 1 } }
      ]
    },
    {
      question: 'What kind of achievement feels most rewarding?',
      answers: [
        { text: 'Doing something brave', points: { gryffindor: 3 } },
        { text: 'Learning something new', points: { ravenclaw: 3 } },
        { text: 'Helping others succeed', points: { hufflepuff: 3 } },
        { text: 'Reaching a big goal', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'Which environment sounds most appealing?',
      answers: [
        { text: 'A place full of adventure', points: { gryffindor: 3 } },
        { text: 'A quiet library filled with ideas', points: { ravenclaw: 3 } },
        { text: 'A warm, welcoming common room', points: { hufflepuff: 3 } },
        { text: 'A refined space with strong purpose', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'How do your friends usually describe you?',
      answers: [
        { text: 'Bold', points: { gryffindor: 3 } },
        { text: 'Thoughtful', points: { ravenclaw: 3 } },
        { text: 'Dependable', points: { hufflepuff: 3 } },
        { text: 'Driven', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'Which role would you most naturally take in a group?',
      answers: [
        { text: 'The one who steps forward first', points: { gryffindor: 3 } },
        { text: 'The strategist or idea person', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'The steady teammate everyone trusts', points: { hufflepuff: 3 } },
        { text: 'The leader shaping the outcome', points: { slytherin: 3, gryffindor: 1 } }
      ]
    },
    {
      question: 'What would you rather be known for?',
      answers: [
        { text: 'Bravery', points: { gryffindor: 3 } },
        { text: 'Wisdom', points: { ravenclaw: 3 } },
        { text: 'Fairness', points: { hufflepuff: 3 } },
        { text: 'Resourcefulness', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'When facing competition, what matters most to you?',
      answers: [
        { text: 'Giving it everything I’ve got', points: { gryffindor: 3 } },
        { text: 'Outsmarting the challenge', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Playing honorably', points: { hufflepuff: 3 } },
        { text: 'Winning through strategy', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'What kind of magic would fascinate you most?',
      answers: [
        { text: 'Defensive magic and daring spells', points: { gryffindor: 3 } },
        { text: 'Ancient knowledge and rare books', points: { ravenclaw: 3 } },
        { text: 'Herbology, creatures, and care', points: { hufflepuff: 3 } },
        { text: 'Powerful and precise spellcraft', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'What do you trust most when making a decision?',
      answers: [
        { text: 'My nerve', points: { gryffindor: 3 } },
        { text: 'My mind', points: { ravenclaw: 3 } },
        { text: 'My heart', points: { hufflepuff: 3 } },
        { text: 'My instincts and long-term plan', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'Which motto feels closest to you?',
      answers: [
        { text: 'Fortune favors the bold', points: { gryffindor: 3 } },
        { text: 'Knowledge is power', points: { ravenclaw: 3, slytherin: 1 } },
        { text: 'Loyalty matters most', points: { hufflepuff: 3 } },
        { text: 'Ambition builds greatness', points: { slytherin: 3 } }
      ]
    },
    {
      question: 'Which final choice sounds most like you?',
      answers: [
        { text: 'Stand up, even when it’s hard', points: { gryffindor: 3 } },
        { text: 'Keep learning, always', points: { ravenclaw: 3 } },
        { text: 'Be true and steadfast', points: { hufflepuff: 3 } },
        { text: 'Aim high and make it happen', points: { slytherin: 3 } }
      ]
    }
  ];

  const HOUSE_RESULTS = {
    gryffindor: {
      name: 'Gryffindor',
      description:
        'You lead with courage, heart, and bold energy. You tend to step forward when others hesitate, and you are often willing to take risks for the people and causes that matter most.',
      secondary: 'Brave, daring, and spirited'
    },
    ravenclaw: {
      name: 'Ravenclaw',
      description:
        'You are guided by curiosity, creativity, and intelligence. You enjoy learning, exploring ideas, and finding meaning in the details others might overlook.',
      secondary: 'Curious, insightful, and imaginative'
    },
    hufflepuff: {
      name: 'Hufflepuff',
      description:
        'You value loyalty, fairness, and kindness. People often trust you because you are steady, welcoming, and the kind of person who shows up when it matters.',
      secondary: 'Loyal, warm, and dependable'
    },
    slytherin: {
      name: 'Slytherin',
      description:
        'You are ambitious, resourceful, and focused. You naturally think ahead, read situations well, and know how to move with purpose toward what you want most.',
      secondary: 'Driven, strategic, and resourceful'
    }
  };

  const createScores = () => ({
    gryffindor: 0,
    ravenclaw: 0,
    hufflepuff: 0,
    slytherin: 0
  });

  const sanitizeTagPart = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  function initSortingSection(section) {
    if (!section || section.dataset.sortingInitialized === 'true') return;
    section.dataset.sortingInitialized = 'true';

    const configScript = section.querySelector('[data-sorting-config]');
    if (!configScript) return;

    let config = { collectionUrls: {}, crestUrls: {} };

    try {
      config = JSON.parse(configScript.textContent);
    } catch (error) {
      console.error('Sorting Hat config parse error', error);
    }

    const steps = {
      age: section.querySelector('[data-step="age"]'),
      under13: section.querySelector('[data-step="under13"]'),
      contact: section.querySelector('[data-step="contact"]'),
      quiz: section.querySelector('[data-step="quiz"]'),
      result: section.querySelector('[data-step="result"]')
    };

    const els = {
      firstName: section.querySelector('[data-input-first-name]'),
      email: section.querySelector('[data-input-email]'),
      ageRange: section.querySelector('[data-input-age-range]'),
      gender: section.querySelector('[data-input-gender]'),
      consent: section.querySelector('[data-input-consent]'),
      contactError: section.querySelector('[data-contact-error]'),
      progress: section.querySelector('[data-progress]'),
      question: section.querySelector('[data-question]'),
      answers: section.querySelector('[data-answers]'),
      next: section.querySelector('[data-next-question]'),
      resultCard: section.querySelector('[data-result-card]'),
      resultGreeting: section.querySelector('[data-result-greeting]'),
      resultHouse: section.querySelector('[data-result-house]'),
      resultSecondary: section.querySelector('[data-result-secondary]'),
      resultDescription: section.querySelector('[data-result-description]'),
      resultFriscoNote: section.querySelector('[data-result-frisco-note]'),
      resultCrest: section.querySelector('[data-result-crest]'),
      crestPlaceholder: section.querySelector('.mh-result-crest-placeholder'),
      shopLink: section.querySelector('[data-shop-link]'),
      emailResultWrap: null,
      emailTags: null,
      emailFirstName: null,
      emailAddress: null,
      emailPreview: null
    };

    const state = {
      collectData: false,
      currentQuestionIndex: 0,
      selectedAnswerIndex: null,
      scores: createScores()
    };

    const showStep = (name) => {
      Object.entries(steps).forEach(([stepName, node]) => {
        if (!node) return;
        node.classList.toggle('mh-hidden', stepName !== name);
      });
    };

    const resetResultCard = () => {
      if (els.contactError) {
        els.contactError.textContent = '';
        els.contactError.classList.add('mh-hidden');
      }

      if (els.resultCard) {
        els.resultCard.classList.remove(
          'is-gryffindor',
          'is-ravenclaw',
          'is-hufflepuff',
          'is-slytherin'
        );
      }

      if (els.resultCrest) {
        els.resultCrest.src = '';
        els.resultCrest.alt = '';
        els.resultCrest.classList.add('mh-hidden');
      }

      els.crestPlaceholder?.classList.remove('mh-hidden');

      if (els.shopLink) {
        els.shopLink.href = '#';
      }
    };

    const restart = () => {
      state.collectData = false;
      state.currentQuestionIndex = 0;
      state.selectedAnswerIndex = null;
      state.scores = createScores();

      if (els.firstName) els.firstName.value = '';
      if (els.email) els.email.value = '';
      if (els.ageRange) els.ageRange.value = '';
      if (els.gender) els.gender.value = '';
      if (els.consent) els.consent.checked = false;

      resetResultCard();
      showStep('age');
    };

    const renderQuestion = () => {
      const currentQuestion = QUESTIONS[state.currentQuestionIndex];
      state.selectedAnswerIndex = null;

      if (els.progress) {
        els.progress.textContent = `Question ${state.currentQuestionIndex + 1} of ${QUESTIONS.length}`;
      }

      if (els.question) {
        els.question.textContent = currentQuestion.question;
      }

      if (!els.answers) return;

      els.answers.innerHTML = '';
      els.next?.classList.add('mh-hidden');

      currentQuestion.answers.forEach((answer, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mh-answer';
        button.textContent = answer.text;

        button.addEventListener('click', () => {
          state.selectedAnswerIndex = index;

          [...els.answers.querySelectorAll('.mh-answer')].forEach((node, i) => {
            node.classList.toggle('is-selected', i === index);
          });

          els.next?.classList.remove('mh-hidden');
        });

        els.answers.appendChild(button);
      });
    };

    const startQuiz = (collectData) => {
      state.collectData = collectData;
      state.currentQuestionIndex = 0;
      state.selectedAnswerIndex = null;
      state.scores = createScores();

      showStep('quiz');
      renderQuestion();
    };

    const nextQuestion = () => {
      if (state.selectedAnswerIndex === null) return;

      const selected = QUESTIONS[state.currentQuestionIndex].answers[state.selectedAnswerIndex];

      Object.entries(selected.points).forEach(([house, points]) => {
        state.scores[house] += points;
      });

      state.currentQuestionIndex += 1;

      if (state.currentQuestionIndex < QUESTIONS.length) {
        renderQuestion();
      } else {
        showResult();
      }
    };

    const showResult = () => {
      showStep('result');

      const rankedHouses = Object.keys(state.scores).sort(
        (a, b) => state.scores[b] - state.scores[a]
      );
      const primaryKey = rankedHouses[0];
      const secondaryKey = rankedHouses[1];
      const primary = HOUSE_RESULTS[primaryKey];
      const secondary = HOUSE_RESULTS[secondaryKey];
      const firstName = els.firstName?.value.trim();

      if (els.resultGreeting) {
        els.resultGreeting.innerHTML = firstName
          ? `<strong>${firstName}</strong>, you have been sorted into`
          : 'You have been sorted into';
      }

      if (els.resultHouse) {
        els.resultHouse.textContent = primary.name;
      }

      if (els.resultSecondary) {
        els.resultSecondary.textContent = `${primary.secondary}. Your secondary match is ${secondary.name}.`;
      }

      if (els.resultDescription) {
        els.resultDescription.textContent = primary.description;
      }

      if (els.shopLink) {
        els.shopLink.href = config.collectionUrls?.[primaryKey] || '#';
      }

      /* Frisco pickup note preserved for future store relaunch.
      if (els.resultFriscoNote) {
        els.resultFriscoNote.innerHTML = `📍 <strong>${primary.name}</strong> favorites can be picked up locally in Frisco. <a class="mh-frisco-store-link" href="/pages/frisco-harry-potter-store">Visit our Frisco store page</a>.`;
      }
      */

      if (els.resultCard) {
        els.resultCard.classList.remove(
          'is-gryffindor',
          'is-ravenclaw',
          'is-hufflepuff',
          'is-slytherin'
        );
        els.resultCard.classList.add(`is-${primaryKey}`);
      }

      if (els.resultCrest && config.crestUrls?.[primaryKey]) {
        els.resultCrest.src = config.crestUrls[primaryKey];
        els.resultCrest.alt = `${primary.name} crest`;
        els.resultCrest.classList.remove('mh-hidden');
      }

      els.crestPlaceholder?.classList.add('mh-hidden');

      if (state.collectData && els.emailResultWrap) {
        const email = els.email?.value?.trim() || '';
        const ageRange = els.ageRange?.value || '';
        const gender = els.gender?.value || '';
        const tags = ['sorting-hat', `house-${primaryKey}`, `secondary-${secondaryKey}`];

        if (ageRange) tags.push(`age-${sanitizeTagPart(ageRange)}`);
        if (gender) tags.push(`gender-${sanitizeTagPart(gender)}`);

        if (els.emailTags) els.emailTags.value = tags.join(',');
        if (els.emailFirstName) els.emailFirstName.value = firstName || '';
        if (els.emailAddress) els.emailAddress.value = email;
        if (els.emailPreview) els.emailPreview.textContent = email || 'your email address';

        els.emailResultWrap.classList.remove('mh-hidden');
      } else if (els.emailResultWrap) {
        els.emailResultWrap.classList.add('mh-hidden');
      }
    };

    section.querySelectorAll('[data-age-gate]').forEach((button) => {
      button.addEventListener('click', () => {
        showStep(button.dataset.ageGate === 'yes' ? 'contact' : 'under13');
      });
    });

    section.querySelector('[data-start-under13]')?.addEventListener('click', () => {
      startQuiz(false);
    });

    section.querySelector('[data-begin-quiz]')?.addEventListener('click', () => {
      const errors = [];
      const firstName = els.firstName?.value.trim() || '';
      const email = els.email?.value.trim() || '';
      const consent = !!els.consent?.checked;

      if (!firstName) {
        errors.push('Please enter your first name.');
      }

      if (!email) {
        errors.push('Please enter your email address.');
      } else if (!validateEmail(email)) {
        errors.push('Please enter a valid email address.');
      }

      if (!consent) {
        errors.push('Please check the consent box to continue.');
      }

      if (errors.length) {
        if (els.contactError) {
          els.contactError.innerHTML = errors.join('<br>');
          els.contactError.classList.remove('mh-hidden');
        }
        return;
      }

      if (els.contactError) {
        els.contactError.classList.add('mh-hidden');
      }

      startQuiz(true);
    });

    section.querySelectorAll('[data-restart]').forEach((button) => {
      button.addEventListener('click', restart);
    });

    els.next?.addEventListener('click', nextQuestion);

    restart();
  }

  function initAllSortingSections(root = document) {
    root.querySelectorAll('.mh-sorting-section').forEach(initSortingSection);

    if (root.matches?.('.mh-sorting-section')) {
      initSortingSection(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSortingSections());
  } else {
    initAllSortingSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      initAllSortingSections(event.target);
    }
  });
})();
